import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { server_post_data } from "../ServiceConnection/serviceconnection"; // Adjust path as needed
import { get_pos_qr_menu } from "../ServiceConnection/serviceconnection"; // Adjust path as needed
import { handleError } from "../CommonJquery/CommonJquery"; // Adjust path as needed
import { retrieveData } from "../LocalConnection/LocalConnection";

const ContactUs = ({ full_name }) => {
  const loading = false;
  const globalData = JSON.parse(retrieveData("QR_GLOBAL_DATA"));

  const restaurant = globalData?.[0];
  const restaurantEmail =
    restaurant?.restaurant_email || "support@uprestro.com";
  const restaurantMobile = restaurant?.restaurant_mobile_no || "";
  const restaurantName = restaurant?.restaurant_name || full_name;
  return (
    <>
      <style>
        {`
          @media (max-width: 768px) {
            .contact-container {
              padding: 20px 10px !important;
            }
            .contact-card {
              padding: 24px 16px !important;
              border-radius: 12px !important;
            }
            .contact-heading {
              font-size: 1.6rem !important;
              margin-bottom: 16px !important;
            }
            .contact-subheading {
              font-size: 1.2rem !important;
              margin-top: 20px !important;
            }
            .contact-text {
              font-size: 14px !important;
            }
            .contact-box {
              padding: 20px 16px !important;
            }
            .contact-item {
              flex-direction: column !important;
              align-items: flex-start !important;
              padding: 16px 12px !important;
            }
            .icon-wrapper {
              margin-right: 0 !important;
              margin-bottom: 10px !important;
            }
            .contact-link {
              font-size: 16px !important;
              word-break: break-word !important;
            }
            .info-section {
              padding: 16px !important;
            }
          }

          @media (max-width: 480px) {
            .contact-heading {
              font-size: 1.4rem !important;
            }
            .contact-subheading {
              font-size: 1.1rem !important;
            }
            .contact-link {
              font-size: 15px !important;
            }
            .contact-icon {
              font-size: 1.5rem !important;
            }
          }

          .contact-link:hover {
            color: #2980b9 !important;
            text-decoration: underline !important;
          }

          .contact-item:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
            transition: all 0.3s ease;
          }

          .loading-spinner {
            text-align: center;
            padding: 50px;
            color: #7f8c8d;
            font-size: 18px;
          }
        `}
      </style>
      <div style={styles.container} className="contact-container">
        <div style={styles.card} className="contact-card">
          {loading ? (
            <div className="loading-spinner">
              <p>Loading...</p>
            </div>
          ) : (
            <>
              <h1 style={styles.heading} className="contact-heading">
                Contact Us
              </h1>

              <p style={styles.text} className="contact-text">
                We're here to help! If you have any questions, concerns, or
                feedback, please feel free to reach out to us using the contact
                information below.
              </p>

              <div style={styles.contactBox} className="contact-box">
                <h3 style={styles.subheading} className="contact-subheading">
                  Get In Touch
                </h3>

                <div style={styles.contactItem} className="contact-item">
                  <div style={styles.iconWrapper} className="icon-wrapper">
                    <span style={styles.icon} className="contact-icon">
                      📧
                    </span>
                  </div>
                  <div style={styles.contactDetails}>
                    <p style={styles.label}>Email</p>
                    <a
                      href={`mailto:${restaurantEmail}`}
                      style={styles.link}
                      className="contact-link"
                    >
                      {restaurantEmail}
                    </a>
                  </div>
                </div>
                <div style={styles.contactItem} className="contact-item">
                  <div style={styles.iconWrapper} className="icon-wrapper">
                    <span style={styles.icon} className="contact-icon">
                      📞
                    </span>
                  </div>
                  <div style={styles.contactDetails}>
                    <p style={styles.label}>Phone</p>
                    <a
                      href={`tel:+91${restaurantMobile}`}
                      style={styles.link}
                      className="contact-link"
                    >
                      +91{restaurantMobile}
                    </a>
                  </div>
                </div>
              </div>

              <div style={styles.infoSection} className="info-section">
                <h3 style={styles.subheading} className="contact-subheading">
                  Business Hours
                </h3>
                <p style={styles.text} className="contact-text">
                  Monday - Sunday: 9:00 AM - 10:00 PM
                </p>
              </div>

              <p style={styles.footerText} className="contact-text">
                We strive to respond to all inquiries within 24 hours. Thank you
                for choosing <strong>{restaurantName || full_name}</strong>!
              </p>
            </>
          )}
        </div>
      </div>
    </>
  );
};

const styles = {
  container: {
    padding: "40px 20px",
    backgroundColor: "#f2f4f8",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  card: {
    backgroundColor: "#ffffff",
    padding: "40px",
    borderRadius: "16px",
    boxShadow: "0px 6px 20px rgba(0,0,0,0.1)",
    maxWidth: "900px",
    width: "100%",
  },
  heading: {
    color: "#2c3e50",
    marginBottom: "20px",
    fontSize: "2.2rem",
    textAlign: "center",
    fontWeight: "600",
  },
  subheading: {
    color: "#2c3e50",
    marginTop: "25px",
    marginBottom: "15px",
    fontSize: "1.4rem",
    fontWeight: "600",
  },
  text: {
    fontSize: "16px",
    color: "#34495e",
    lineHeight: "1.7",
    marginBottom: "12px",
  },
  contactBox: {
    backgroundColor: "#f8f9fa",
    padding: "30px",
    borderRadius: "12px",
    marginTop: "30px",
    marginBottom: "30px",
  },
  contactItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    padding: "18px",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  iconWrapper: {
    marginRight: "20px",
    fontSize: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    fontSize: "2rem",
  },
  contactDetails: {
    flex: 1,
    minWidth: 0,
  },
  label: {
    fontSize: "14px",
    color: "#7f8c8d",
    marginBottom: "5px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  link: {
    fontSize: "18px",
    color: "#3498db",
    textDecoration: "none",
    fontWeight: "500",
    display: "block",
    wordWrap: "break-word",
  },
  infoSection: {
    backgroundColor: "#e8f4f8",
    padding: "20px",
    borderRadius: "8px",
    marginTop: "20px",
    marginBottom: "20px",
  },
  footerText: {
    marginTop: "30px",
    textAlign: "center",
    fontSize: "16px",
    color: "#7f8c8d",
    fontStyle: "italic",
    lineHeight: "1.6",
  },
};

export default ContactUs;
